import React from 'react';

import styles from './CurrentDue.module.css';
import CurrentPaymentMethod from './CurrentPaymentMethod';
import AutopayIcon from './AutopayIcon';

import SubBox from 'common/SubBox';

const NoBill = ({ paymentMethod, user }) => (
  <React.Fragment>
    <span className={styles.upToDate}>
      You have nothing due for the current cycle
    </span>
    <CurrentPaymentMethod paymentMethod={paymentMethod} />
    <SubBox>
      <AutopayIcon enabled={user.autopay_enabled} />
    </SubBox>
  </React.Fragment>
)

export default NoBill;
